export default __webpack_public_path__ + "static/media/hht1_ep06_timeline_q01_b.62569695.png";